module.exports = __webpack_public_path__ + "static/img/logo_021.a5e1eabf.png";